<template>
    <div style="margin-bottom: -5px;" class="row  go-form-row" v-show="inputItem.display == null ? true : inputItem.display">
        <go-label :labelWidth="labelWidth" :labelAlign="labelAlign" :item="inputItem"></go-label>
        <DatePicker @on-change="changeDate" :class="'go-content ' + getInputWid()"  type="daterange" placement="bottom-end" :placeholder="inputItem.placeholder" ></DatePicker>
    </div>
</template>

<script>
    import formMixin from "../../mixins/formMixins";
    import GoLabel from "./commponents/go-label";

    export default {
        name: "go-calendar-range",
        mixins: [formMixin],
        props: {

        },
        computed: {

        },
        mounted() {

        },
        methods: {
            changeDate(date){
                this.$emit('input', date);
            }
        },
        watch: {},
        beforeDestroy(){

        },
        components: {
            GoLabel
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-calendar-range.vue